export const commonConstant = {
  PAGE_DEFAULT: 1,
  PAGE_SIZE_DEFAULT: 100,
  PAGE_OPTIONS: [20, 50, 100],

  ADMIN: 'ADMIN',
  USER: 'USER',

  MENU: {
    dashboard: 'ダッシュボード',
    revenue: '売上管理',
    user: 'ユーザーリスト',
  },

  MESSAGE: {
    unauthorized: 'Unauthorized',
    internalServerError: 'Internal Server Error',
  },

  SCROLL_THRESHOLD: 20,

  REGEX: {
    // Alphanumeric, 4-20 characters
    USENAME_RULE: /^[A-Za-z0-9]{4,20}$/,

    // Minimum 8 characters, at least one uppercase letter, one lowercase letter and one number
    PASSWORD_RULE: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/,
  },
};
